import { AxiosError } from 'axios';

/**
 * Throws the given error if it is not an Axios error.
 * @template T Type of the axios response's data
 * @param e Potential error object
 */
export default function assertIsAxiosError<T = unknown>(
    e: unknown | AxiosError<T>
): asserts e is AxiosError<T> {
    if (!(e as AxiosError<T>).isAxiosError) {
        throw e;
    }
}
